<template>
  <div
    v-if="categoriesWithTasks.length > 0"
    class="flex flex-wrap gap-2 border-b pb-2"
  >
    <button
      v-for="category in categoriesWithTasks"
      :key="category.id"
      type="button"
      data-test="quick-category"
      class="flex items-center gap-2 rounded-md border px-3 py-1 text-sm transition"
      :class="{
        'border-primary bg-primary text-white': selectedId === category.id,
        'bg-gray-100 hover:bg-gray-200 dark:border-slate-600 dark:bg-slate-700 dark:text-gray-100 dark:hover:bg-slate-600':
          selectedId !== category.id
      }"
      :title="
        $t('global.tasks_shown_of_total', {
          shown: category.shown,
          total: category.total
        })
      "
      @click="
        $emit(
          'update:selectedId',
          selectedId === category.id ? null : category.id
        )
      "
    >
      <span
        class="flex h-6 min-w-6 items-center justify-center rounded-full px-1 text-xs font-bold"
        :class="{
          'bg-white text-primary': selectedId === category.id,
          'bg-gray-300 text-gray-700 dark:bg-slate-500 dark:text-gray-100':
            selectedId !== category.id
        }"
      >
        {{ category.shown }}
      </span>
      <span>{{ category.name }}</span>
      <span class="text-xs opacity-70">/ {{ category.total }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TaskQuickCategoryFilters',
  props: {
    categories: { type: Array, required: true },
    counts: { type: Object, required: true },
    totals: { type: Object, required: true },
    selectedId: { type: String, required: false, default: null }
  },
  emits: ['update:selectedId'],
  computed: {
    categoriesWithTasks() {
      return this.categories
        .map((category) => ({
          ...category,
          shown: this.counts[category.id] ?? 0,
          total: this.totals[category.id] ?? 0
        }))
        .filter(
          (category) => category.shown > 0 || category.id === this.selectedId
        )
    }
  }
}
</script>
